export enum CancelOptions {
  IMMEDIATE_CANCEL = 'immediate',
  SCHEDULED_CANCEL = 'scheduled',
  DELAYED_CANCEL = 'delayed',
}
